import axios from "axios"
import config from "../config"
import { Feedback } from "../entities/Feedback"

export async function PostFeedback(feedback: Feedback) {
  const response = await axios.post(`${config.api}/feedback/`, feedback)
  return response.data
}
